export default [
  {
    path: 'contractor/:contractorId/license/create/:templateId',
    name: 'createContractorLicense',
    component: () => import('@/views/Contractor/License/Create.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-contractors',
      template: 'auth',
    },
  },
  {
    path: 'contractor/:contractorId/license/:licenseId/update',
    name: 'updateContractorLicense',
    component: () => import('@/views/Contractor/License/Update.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-contractors',
      template: 'auth',
    },
  },
  {
    path: 'contractor/:contractorId/license/:licenseId/version',
    name: 'updateVersionContractorLicense',
    component: () => import('@/views/Contractor/License/CurrentVersionUpdate.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-contractors',
      template: 'auth',
    },
  },
  {
    path: 'contractor/:contractorId/contract/:contractId',
    name: 'OldContractorContractContent',
    component: () => import('@/views/Contractor/Contract/Show.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-contractors',
      template: 'auth',
    },
  },
  {
    path: 'contractor/:contractorId/contract/:contractId/update',
    name: 'updateContractorContract',
    component: () => import('@/views/Contractor/Contract/Update.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-contractors',
      template: 'auth',
    },
  },
  {
    path: 'contractor/:contractorId/contract-create',
    name: 'createContractorContract',
    component: () => import('@/views/Contractor/Contract/Create.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-contractors',
      template: 'auth',
    },
  },
  {
    path: 'contractor-license-template-content/:templateId',
    name: 'contractorTemplateContent',
    component: () => import('@/views/Contractor/License/ShowTemplate.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-contractor',
      template: 'auth',
    },
  },
  {
    path: 'printing/contractor_operation_result/:operationResultId',
    name: 'PrintingContractorOperationResult',
    component: () => import('@/views/Printing/ContractorOperationResult.vue'),
    props: true,
    meta: {
      name: 'printing-contractor-operation-result',
      middleware: 'auth',
      template: 'printing',
    },
  },
  {
    path: 'printing/contractor-operation',
    name: 'PrintingContractorOperation',
    component: () => import('@/views/Printing/ContractorOperation.vue'),
    props: true,
    meta: {
      name: 'printing-contractor-operation',

      middleware: 'auth',
      template: 'printing',
    },
  },
  {
    path: 'contractors',
    name: 'contractors',
    component: () => import('@/views/Contractor/Index.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-contractor',
      template: 'auth',
    },
  },
  {
    path: 'contractor-create',
    name: 'contractorCreate',
    component: () => import('@/views/Contractor/Create.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-contractor',
      template: 'auth',
    },
  },
  {
    path: 'contractor-update/:contractorId',
    name: 'contractorUpdate',
    component: () => import('@/views/Contractor/Update.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-contractor',
      template: 'auth',
    },
  },
  {
    path: 'contractor/:contractorId/contractor-license-create-basic/:templateId',
    name: 'contractorLicenseCreate',
    component: () => import('@/views/Contractor/License/Create.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-contractor',
      template: 'auth',
    },
  },
  {
    path: 'contractor/:contractorId/contractor-license-create-version/:licenseId',
    name: 'contractorLicenseCreateVersion',
    component: () => import('@/views/Contractor/License/Update.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-contractor',
      template: 'auth',
    },
  },
  {
    path: 'contractor/:contractorId/contractor-license-update-version/:licenseId',
    name: 'contractorLicenseUpdateVersion',
    component: () => import('@/views/Contractor/License/CurrentVersionUpdate.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-contractor',
      template: 'auth',
    },
  },
  {
    path: 'contractor/:contractorId/contractor-license-content/:licenseId',
    name: 'contractorLicenseContent',
    component: () => import('@/views/Contractor/License/Show.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-contractor',
      template: 'auth',
    },
  },
  {
    path: 'contractor/:contractorId/contractor-contract-content/:contractId',
    name: 'contractorContractContent',
    component: () => import('@/views/Contractor/Contract/Show.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-contractor',
      template: 'auth',
    },
  },
  {
    path: 'contractor/:contractorId/contractor-contract-update/:contractId',
    name: 'contractorContractUpdate',
    component: () => import('@/views/Contractor/Contract/Update.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-contractor',
      template: 'auth',
    },
  },
  {
    path: 'contractor/:contractorId/contractor-contract-create',
    name: 'contractorContractCreate',
    component: () => import('@/views/Contractor/Contract/Create.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-contractor',
      template: 'auth',
    },
  },
  {
    path: 'contractor-content/:contractorId',
    name: 'contractorContent',
    props: true,
    component: () => import('@/views/Contractor/Show.vue'),
    meta: {
      middleware: 'auth',
      name: 'management-contractor',
      template: 'auth',
    },
  },
  {
    path: 'contractor-operations',
    name: 'contractorOperations',
    component: () => import('@/views/ContractorOperation/Index.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-operation',
      template: 'auth',
    },
  },
  {
    path: 'contractor-operation-content/:operationId',
    name: 'contractorOperationContent',
    component: () => import('@/views/ContractorOperation/Show.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-operation',
      template: 'auth',
    },
  },
  {
    path: 'contractor-operation-create',
    name: 'contractorOperationCreate',
    component: () => import('@/views/ContractorOperation/Create.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-operation',
      template: 'auth',
    },
  },
  {
    path: 'contractor-operation-update/:operationId',
    name: 'contractorOperationUpdate',
    component: () => import('@/views/ContractorOperation/Update.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-operation',
      template: 'auth',
    },
  },
  {
    path: 'contractor-operation-assignment/:operationAssignmentId',
    name: 'contractorOperationAssignment',
    component: () => import('@/views/ContractorOperation/Assignment.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-operation',
      template: 'auth',
    },
  },
  {
    path: 'contractor-operation-result-view/:operationResultId',
    name: 'contractorOperationResult',
    component: () => import('@/views/ContractorOperation/Result.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-operation',
      template: 'auth',
    },
  },
  {
    path: 'contractor-license-template-content/:templateId',
    name: 'contractorLicenseTemplateContent',
    component: () => import('@/views/Contractor/License/ShowTemplate.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-contractor',
      template: 'auth',
    },
  },
  {
    path: 'print-contractor-operation-result/:operationResultId',
    name: 'printContractorOperationResult',
    component: () => import('@/views/Printing/ContractorOperationResult.vue'),
    props: true,
    meta: {
      name: 'printContractorOperationResult',
      middleware: 'auth',
      template: 'printing',
    },
  },
  {
    path: 'print-contractor-operation-basic',
    name: 'printContractorOperation',
    component: () => import('@/views/Printing/ContractorOperation.vue'),
    props: true,
    meta: {
      name: 'printContractorOperation',
      middleware: 'auth',
      template: 'printing',
    },
  },
];
